import React from 'react';
import {Trans} from 'react-i18next';
import LeftTitleWithField from '../../layout/LeftTitleWithField';
import {Field} from 'formik';
import _get from 'lodash/get';
import CustomSwitch from '../../../../../components/layout/CustomSwitch';
import Section from '../../layout/Section';
import InputBox from '../../../../../components/formik/InputBox';
import Select from 'react-select';
import langUtils from '../../../../../utils/langUtils';
import useSkincare from '../../../../../components/hook/useSkincare';
import {useSelector} from 'react-redux';

export default function GeneralSection({formikProps}) {
  const accountSummary = useSelector(
    state => state.components.auth.accountSummary
  );
  const {isVersionAbove2AndHd} = useSkincare(accountSummary);

  return (
    <Section
      title={
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.general">
          General
        </Trans>
      }
    >
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.enable.recommendation">
            Enable Recommendation
          </Trans>
        }
      >
        <Field
          name="skinResultPage.general.enableRecommendation"
          value={_get(formikProps.values, 'skinResultPage.general.enableRecommendation')}
          component={CustomSwitch}
        />
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.show.getreport">
            Show "Get Report" Button on Footer
          </Trans>
        }
      >
        <Field
          name="skinResultPage.general.showFooterButton"
          value={_get(formikProps.values, 'skinResultPage.general.showFooterButton')}
          component={CustomSwitch}
        />
      </LeftTitleWithField>
      {isVersionAbove2AndHd && (
        <LeftTitleWithField
          title={
            <Trans i18nKey="p.s.uiconfiguration.skinresultpageultpage.button.getreport">
              "Get Report" Button Text
            </Trans>
          }
        >
          <div className="d-flex flex-row">
            <Select
              className="kt-margin-r-10"
              options={langUtils.getAppLangList()}
              onChange={o => {
                formikProps.setFieldValue(
                  'skinResultPage.general.getSkinReportButtonTextLanguage',
                  o
                );
              }}
              value={_get(
                formikProps.values,
                'skinResultPage.general.getSkinReportButtonTextLanguage',
                langUtils.getAppLangList().find(l => l.value === 'enu') ||
                  langUtils.getAppLangList()[0]
              )}
              isSearchable={false}
              isClearable={false}
              placeholder={
                <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
              }
              styles={{
                control: base => ({
                  ...base,
                  height: '45px',
                }),
              }}
            />
            <Field
              name={`skinResultPage.general.getSkinReportButtonText.${_get(
                formikProps.values,
                'skinResultPage.general.getSkinReportButtonTextLanguage.value',
                'enu'
              )}`}
              maxLength={langUtils.getAdjustedMaxLength(
                30,
                _get(
                  formikProps.values,
                  'skinResultPage.general.getSkinReportButtonTextLanguage.value',
                  'enu'
                )
              )}
              component={InputBox}
              style={{height: '45px'}}
            />
          </div>
        </LeftTitleWithField>
      )}
    </Section>
  );
}
